import {Box, Container, styled} from '@mui/material';
import {StyledFooterContainerProps} from './types';

const CustomContainer = styled(Container)`
	margin-top: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-top: 24px;
	}
`;

const StyledFooterContainer = styled(Box)<StyledFooterContainerProps>`
	margin: auto 0px 72px;
	padding-top: 40px;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin: auto 0px 0px;
		& footer {
			margin-inline: 24px;
		}
	}

	${({theme}) => theme.breakpoints.up('md')} {
		margin: auto 24px 0px;
		& footer {
			margin-inline: 0px;
		}
	}
`;

const StyledBox = styled(Box)`
	background-color: ${({theme}) => theme.palette.background.paper};
	width: 100%;
	padding: 16px;
	border-radius: 8px;
`;

export {CustomContainer, StyledFooterContainer, StyledBox};
